var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2994 8.96896L3.23692 2.43771C3.13454 2.38651 3.01954 2.36599 2.90577 2.37863C2.79201 2.39127 2.68432 2.43653 2.59567 2.50896C2.51102 2.57991 2.44783 2.67306 2.41322 2.77795C2.3786 2.88284 2.37393 2.99531 2.39973 3.10271L4.15723 9.4974L2.37598 15.8743C2.35177 15.964 2.34895 16.0581 2.36773 16.1491C2.38652 16.24 2.42639 16.3253 2.48414 16.3981C2.54189 16.4709 2.61591 16.5291 2.70025 16.568C2.78459 16.607 2.87689 16.6256 2.96973 16.6224C3.06268 16.6218 3.1542 16.5995 3.23692 16.5571L16.2994 10.0258C16.3967 9.97601 16.4783 9.90031 16.5353 9.80707C16.5923 9.71383 16.6224 9.60667 16.6224 9.4974C16.6224 9.38812 16.5923 9.28096 16.5353 9.18772C16.4783 9.09448 16.3967 9.01878 16.2994 8.96896ZM3.89005 14.9065L5.20223 10.0911H10.6885V8.90365H5.20223L3.89005 4.08833L14.7022 9.4974L3.89005 14.9065Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSend);
export default __webpack_public_path__ + "static/media/carbon-send.643d559a5813b990674c31003fb1199c.svg";
export { ForwardRef as ReactComponent };